const breakpoints: { [index: string]: number } = {
  xs: 25,
  sm: 37.5,
  md: 56.25,
  lg: 75,
  xl: 96
};

export const mq = Object.keys(breakpoints)
  .map(key => [key, breakpoints[key]] as [string, number])
  .reduce((prev, [key, breakpoint]) => {
    // eslint-disable-next-line no-param-reassign
    prev[key] = `@media (max-width: ${breakpoint}rem)`;
    return prev;
  }, {} as { [index: string]: string });
